'use client';

/**
 * FadeSlideIn — fades + slides its children in on mount. Shared "content
 * arriving" entrance used by the thinking timeline's expand and the RAG
 * media cards (extracted from thinking-block so both paths animate
 * identically). Mount-keyed: re-mount replays it, prop changes don't.
 */

import React, { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

export function FadeSlideIn({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const id = requestAnimationFrame(() => setShown(true));
    return () => cancelAnimationFrame(id);
  }, []);
  return (
    <div
      className={cn(
        'transition-all duration-300 ease-out',
        // opacity-[1]/opacity-[0] arbitrary values, never Bootstrap's
        // !important .opacity-100/.opacity-0 (tree-wide collision rule).
        shown ? 'translate-y-0 opacity-[1]' : '-translate-y-1 opacity-[0]'
      )}
    >
      {children}
    </div>
  );
}

export default FadeSlideIn;
